import { Loading } from '@shared-ui/components'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { RightSection } from 'widgets/RightSection'

export const OnboardingLayout = () => {
    return (
        <Suspense
            fallback={
                <div className="grid min-h-screen place-items-center text-xl font-bold">
                    <Loading />
                </div>
            }
        >
            <div className="flex flex-col sm:flex-row md:flex-row lg:flex-row">
                <Outlet />
                <RightSection />
            </div>
        </Suspense>
    )
}
